import React from "react";
import { sum } from "lodash";

import "./style.css";

const OperatorConversionsTable = ({ data }) => {
  const conversions = data.conversions ?? [];
  const operator = data.operator ?? {};

  return (
    <div className="operator-conversion-table-widget">
      <div className="heading-container">
        <h6 className="widget-title">
          Operator Conversions - Package Breakdown
        </h6>
        <h6 className="widget-subtitle">{`${operator.name} (${operator.memberId})`}</h6>
      </div>
      <table>
        <thead>
          <tr>
            <th scope="col">package</th>
            <th scope="col">Total</th>
            <th scope="col">type</th>
            <th scope="col">cash</th>
            <th scope="col">card</th>
            <th scope="col">sub total</th>
          </tr>
        </thead>
        <tbody>
          {/* Package wise view */}
          {conversions.map((conversion, index) => {
            const backgroundIdx = index % 2;
            const rowBackground = `package-row-${backgroundIdx}`;
            return (
              <>
                <tr className={`new-conversions ${rowBackground}`}>
                  <td rowSpan={2} className="package-name">
                    {conversion.pricingTierId}
                  </td>
                  <td rowSpan={2} className="total-conversions">
                    {sum([
                      conversion.new.total ?? 0,
                      conversion.renew.total ?? 0,
                    ])}
                  </td>
                  <td className="conversion-type">new</td>
                  <td className="cash-conversions">
                    {conversion.new.cash ?? 0}
                  </td>
                  <td className="card-conversions">
                    {conversion.new.card ?? 0}
                  </td>
                  <td className="total-conversions">
                    {conversion.new.total ?? 0}
                  </td>
                </tr>
                <tr className={`rennew-conversions ${rowBackground}`}>
                  <td className="conversion-type">renew</td>
                  <td className="cash-conversions">
                    {conversion.renew.cash ?? 0}
                  </td>
                  <td className="card-conversions">
                    {conversion.renew.card ?? 0}
                  </td>
                  <td className="total-conversions">
                    {conversion.renew.total ?? 0}
                  </td>
                </tr>
              </>
            );
          })}
          {/* Operator Total */}
          <tr className="sub-total-row">
            <td colSpan={3} className="heading">
              Total Conversions
            </td>
            <td>{data.sum.cash ?? 0}</td>
            <td>{data.sum.card ?? 0}</td>
            <td>{data.sum.total ?? 0}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(OperatorConversionsTable);
